function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.52649 8.59074C1.52649 8.59074 4.35982 2.92407 9.31816 2.92407C14.2765 2.92407 17.1098 8.59074 17.1098 8.59074C17.1098 8.59074 14.2765 14.2574 9.31816 14.2574C4.35982 14.2574 1.52649 8.59074 1.52649 8.59074Z",
  stroke: "#0F172A",
  strokeWidth: 1.41667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.31816 10.7157C10.4918 10.7157 11.4432 9.76434 11.4432 8.59074C11.4432 7.41713 10.4918 6.46574 9.31816 6.46574C8.14455 6.46574 7.19316 7.41713 7.19316 8.59074C7.19316 9.76434 8.14455 10.7157 9.31816 10.7157Z",
  stroke: "#0F172A",
  strokeWidth: 1.41667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgShowPassword = function SvgShowPassword(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShowPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ShowPassword.fd86bd9f.svg";
export { ForwardRef as ReactComponent };